import React from "react";
import { Modal, Form, Button, Table, Spin, message } from "antd";
import { inject, observer } from "mobx-react";
import zhCN from "antd/es/locale-provider/zh_CN";

import renderExpandedRow from "./renderExpandedRow";
import SliderFunc from "./sliderFunc";
import InputCustom from "../../../common/Input";

import "./style/index.scss";
import { $util } from "../../../../helper";
import { recruitTypeOptions } from "./sliderFunc/filterJob";

export const FormContext = React.createContext();

const searchInputPlaceholder = "请输入感兴趣的职位";

@inject("languageStore", "authStore", "gameStore", "commonStore")
@observer
class JobSelect extends React.Component {
  positionsSortMap = recruitTypeOptions.map((item) => item.key);

  renderAction = (id, record) => {
    const jobSelectType = this.props.jobSelectType,
      primaryJobId = this.props.primaryJobId,
      isXZPosition = this.includesTransferPositionCodes.includes(
        record.recruitmentType
      );

    // 如果当前选择职位为调剂职位，那么只能选择校招类型的职位，且不允许和第一职位相同
    if (
      jobSelectType === "primary" ||
      (jobSelectType === "transfer" &&
        primaryJobId !== record.positionId &&
        isXZPosition)
    ) {
      return (
        <div
          className="jobSelectModal__table--action"
          onClick={(e) => this.handleSelectJob(e, record)}
        >
          {"选择"}
        </div>
      );
    }
    return <div className="jobSelectModal__table--no-action">{"选择"}</div>;
  };

  // 选择的第一个职位类型为以下时，可以选择调剂职位
  includesTransferPositionCodes = ["XZ-02"];

  columns = [
    {
      title: "职位名称",
      dataIndex: "jobTitle",
      key: "jobTitle",
      width: "35%",
    },
    {
      title: "职位分类",
      dataIndex: "positionCategory",
      key: "positionCategory",
      width: "14%",
    },
    {
      title: "工作地点",
      dataIndex: "locationDescription",
      key: "locationDescription",
      width: "14%",
    },
    {
      title: "职位类型",
      dataIndex: "recruitmentName",
      key: "recruitmentName",
      width: "14%",
    },
    {
      title: "所属团队",
      dataIndex: "team",
      key: "team",
      width: "14%",
    },
    {
      title: "操作",
      width: "14%",
      dataIndex: "id",
      render: this.renderAction,
    },
  ];

  state = {
    data: [],
    positionCategory: [],
    teamEnum: [],
    workCity: [],
    isContentLoading: true,
    isTableLoading: true,
    isFiltersLoading: true,
    currentPage: 1,
    totalCount: 0,
    totalPage: 0,
    pageSize: 10,
    isSelectSZ: false,
    isResetPage: true,
  };

  componentDidMount() {
    this.getFilterItems();
    this.searchJob();
  }

  getFilterItems = async () => {
    const res = await this.props.gameStore.getFilterItems();
    if (res && res.status === 0) {
      const { positionCategory, teamEnum, workCity } = res;
      this.setState({
        positionCategory,
        teamEnum,
        workCity: (workCity && workCity.cityList) || [],
      });
    }
    this.setState({
      isFiltersLoading: false,
    });
  };

  getIndex = (code) =>
    this.positionsSortMap.findIndex((item) => item.includes(code));

  /**
   * 职位排序规则
   * 1.秋季校园招聘> 大咖招聘计划 > 实习生招聘 > 社会招聘
   * 2.发布时间倒序
   * 3.id倒序
   */
  sortDatas = (datas) => {
    if (Array.isArray(datas) && datas.length > 0) {
      return datas.sort((itemA, itemB) => {
        const recruitmentTypeAIndex = this.getIndex(itemA.recruitmentType),
          recruitmentTypeBIndex = this.getIndex(itemB.recruitmentType),
          createdateA = new Date(itemA.createdate).getTime(),
          createdateB = new Date(itemB.createdate).getTime();

        if (recruitmentTypeAIndex !== recruitmentTypeBIndex) {
          return recruitmentTypeAIndex - recruitmentTypeBIndex;
        } else if (createdateA !== createdateB) {
          return createdateB - createdateA;
        } else {
          return itemB.positionId - itemA.positionId;
        }
      });
    }
    return [];
  };

  searchJob = $util.debounce(async () => {
    this.setState({
      isTableLoading: true,
    });
    const values = this.props.form.getFieldsValue();
    try {
      const { category, city, query, team, type } = values;
      const { currentPage, pageSize, isResetPage } = this.state;
      let project = type;
      if (Array.isArray(type) && type.length > 0) {
        project = type
          .map((item) => item.split(","))
          .reduce((pre, cur) => {
            return pre.concat(cur);
          });
      }
      if (!project || (Array.isArray(project) && project.length === 0)) {
        project = [
          "XZ-02",
          "RM-09",
          "DN-08",
          "SXS-03",
          "SZ-01",
          "LX-04",
          "JZ-05",
          "GW-06",
          "WB-07",
        ];
      }
      const res = await this.props.gameStore.getPosition({
        currentPage: isResetPage ? 1 : currentPage,
        pageSize: isResetPage ? 10 : pageSize,
        // 只为搜索关键字
        keyWord: query,
        // 招聘项目
        recruitmentTypes: project,
        // 城市
        cityList: city,
        // 团队
        teamList: team,
        // 职位类别
        positionCategoryList: category,
      });
      if (res && res.status === 0 && res.data) {
        const { totalCount, datas, currentPage, pageSize } = res.data;
        this.setState({
          data: this.sortDatas(datas),
          totalCount,
          currentPage,
          pageSize,
        });
      } else {
        this.setState({
          data: [],
        });
      }
    } catch (error) {
      console.error(error);
      message.error("获取职位信息失败，请刷新页面重试。");
    }
    this.setState({
      isContentLoading: false,
      isTableLoading: false,
      isResetPage: true,
    });
  }, 300);

  handleOnSubmit = (e) => {
    e.preventDefault();
    this.searchJob();
  };

  handleSelectJob = (e, record) => {
    e.stopPropagation();
    this.props.jobSelectType === "primary" &&
      this.props.changeTransferPositionState(
        this.includesTransferPositionCodes.includes(record.recruitmentType)
      );
    this.props.onSelect(record, this.props.jobSelectType);
    this.props.commonStore.gTag("event", "selectPosition", {
      pageName: "personGameApplyInfo",
      buttonName: "选择",
      positionName: record.jobTitle,
    });
  };

  handleOnChange = (e) => {
    if (e.target && e.target.placeholder === searchInputPlaceholder) {
      return;
    }
    this.searchJob();
  };

  handleOnClear = () => {
    this.searchJob();
  };

  handlePaginationChange = (page) => {
    this.setState(
      {
        currentPage: page,
        isResetPage: false,
      },
      this.searchJob
    );
  };

  handlePaginationSizeChange = (current, size) => {
    this.setState(
      {
        pageSize: size,
        currentPage: 1,
        isResetPage: false,
      },
      this.searchJob
    );
  };

  startSearch = () => {
    const values = this.props.form.getFieldValue("query");
    this.props.commonStore.gTag("event", "searchPosition", {
      pageName: "personGameApplyInfo",
      buttonName: "查找",
      result: values,
    });
  };

  render() {
    const { visible, onCancel } = this.props;
    const { getFieldDecorator } = this.props.form;

    const {
      data,
      isContentLoading,
      isTableLoading,
      isFiltersLoading,
      positionCategory,
      teamEnum,
      workCity,
      currentPage,
      totalCount,
      pageSize,
    } = this.state;

    const tabPagination = {
      total: totalCount,
      current: currentPage,
      pageSize,
      showTotal: (total) => `共 ${total} 条`,
      showQuickJumper: false,
      showSizeChanger: true,
      locale: zhCN.Pagination,
      onChange: this.handlePaginationChange,
      onShowSizeChange: this.handlePaginationSizeChange,
    };

    return (
      <Modal
        className="jobSelectModal"
        visible={visible}
        getContainer={false}
        afterClose={this.afterClose}
        onCancel={onCancel}
        footer={null}
        width={"80vw"}
      >
        {isContentLoading || isFiltersLoading ? (
          <div className="jobSelectModal--loading">
            <Spin />
          </div>
        ) : (
          <Form
            className="jobSelectModal__form"
            onSubmit={this.handleOnSubmit}
            onChange={this.handleOnChange}
          >
            <FormContext.Provider
              value={{ form: this.props.form, searchJob: this.searchJob }}
            >
              <div className="jobSelectModal__topFunc">
                <Form.Item className="jobSelectModal__topFunc--formItem">
                  {getFieldDecorator("query")(
                    <InputCustom
                      className="jobSelectModal__topFunc--input"
                      placeholder={searchInputPlaceholder}
                      allowClear
                      onClear={this.handleOnClear}
                    />
                  )}
                </Form.Item>
                <Button
                  className="jobSelectModal__topFunc--search"
                  type="primary"
                  htmlType="submit"
                  onClick={this.startSearch}
                >
                  {"查找"}
                </Button>
              </div>
              <div className="jobSelectModal__content">
                <SliderFunc {...{ positionCategory, teamEnum, workCity }} />
                <Table
                  className="jobSelectModal__table"
                  columns={this.columns}
                  dataSource={data}
                  expandedRowRender={renderExpandedRow}
                  scroll={{ y: "calc(70vh - 118px)" }}
                  pagination={tabPagination}
                  loading={isTableLoading}
                  defaultExpandAllRows={false}
                  rowKey={"id"}
                />
              </div>
            </FormContext.Provider>
          </Form>
        )}
      </Modal>
    );
  }
}

export default Form.create()(JobSelect);



// WEBPACK FOOTER //
// ./src/components/formList/gameForm/jobSelect/index.js